import React from 'react';
import PropTypes from 'prop-types';

import {Commands as ModuleCommands} from 'views/module';

import {simplifyQuestions} from 'utils/user_bio';

const SlashCommands = (props) => {
  const {caregiverBackend, caregiverBioQuestions, caregiverRn, caregiverData} = props;

  const caregiverBio = React.useMemo(() => {
    if (!caregiverBioQuestions?.questions) {
      return {};
    }

    return simplifyQuestions(caregiverBioQuestions.questions);
  }, [caregiverBioQuestions]);

  const slashCommandProps = React.useMemo(() => {
    const email = caregiverBio.email;
    const defaultRelationship = {
      relationshipRn: caregiverRn,
      name: caregiverData.caregiverName,
      email,
    };
    const [firstName, ...lastNameParts] = caregiverData.caregiverName.split(' ');

    return {
      communicationTarget: {
        defaultRelationship,
        email,
        getRelationshipEmail: (relationship) => relationship?.email || '',
        relationships: [defaultRelationship],
        sendEmail: async (emailData, _relationshipRn, onSuccess, onError=()=>undefined) => {
          return caregiverBackend.messages.sendEmail(caregiverRn, emailData, onSuccess, onError);
        },
      },
      resources: [
        {type: 'CAREGIVER', rn: caregiverRn, firstName, lastName: lastNameParts.join(' ')},
      ],
      playbook: {
        execute: async (playbookRn, primaryResourceRn) => {
          await caregiverBackend.playbooks.execute(playbookRn, primaryResourceRn);
        },
      },
    };
  }, [caregiverBackend, caregiverBio, caregiverData, caregiverRn]);

  return (
    <ModuleCommands
      {...slashCommandProps}
    />
  );
};

SlashCommands.propTypes = {
  caregiverBackend: PropTypes.object.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
};

export default React.memo(SlashCommands);
